module.exports = __webpack_public_path__ + "img/Rhonda_Morris@1x.8abb7a2f.webp";